module.exports = "[mat-dialog-title] {\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: row; }\n\n.icone {\n  cursor: pointer; }\n"